<template>
  <v-dialog
      v-model="familyHistDialog"
       width="1000"
    >
     <template v-slot:activator="{ on }">
            <v-btn :disabled='!currentPatient.familyHistory.length > 0' v-on="on" depressed color="primary">Review Family History</v-btn>
      </template>
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
         Review Family History
        </v-card-title>

        <v-card-text>
          <v-subheader class='mt-5'>Ancestry</v-subheader>
          <p> maternal : {{currentPatient.health.ancestry.maternal}} </p>
          <p> paternal : {{currentPatient.health.ancestry.paternal}} </p>
        <familyHistory :uid='currentPatient.uid' :familyHistoryArr='currentPatient.familyHistory' />
         <v-textarea
          class='pt-5'
          v-model='currentPatient.report.familyHistoryComment'
           auto-grow  
          outlined
          name="input-7-4"
          label="GC Comments"
          placeholder="Enter comments here"
        ></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
       
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
           @click='familyHistDialog = false'
          >
            Complete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import familyHistory from "../../familyHistory"
export default {
    data() {
      return {
        isEmptyFamily : false,
        familyHistDialog : false
      }
    },
    props : {
        currentPatient : Object
    },
  components : {
    familyHistory
  },
  mounted(){
  }
}
</script>

<style>

</style>